import { useDtoolsPdfPackageMode } from "@/components/sales/dtools/DtoolsPdfPackageContext";
import { PROPOSAL_ACCENT, PROPOSAL_COPY_FONT } from "@/lib/proposalTheme";
import { PDF_BODY_CLASS, PDF_EYEBROW_CLASS } from "@/lib/proposalPdfTypography";

type Props = {
  body: string;
};

export default function DtoolsWhyThisOptionPanel({ body }: Props) {
  const pdfPackageMode = useDtoolsPdfPackageMode();
  const trimmed = body.trim();
  if (!trimmed) return null;

  return (
    <div
      className={`rounded-xl border border-[#1A2744]/10 bg-white ${pdfPackageMode ? "p-3" : "p-5 sm:p-6"}`}
      style={{ fontFamily: PROPOSAL_COPY_FONT }}
    >
      <p className={pdfPackageMode ? PDF_EYEBROW_CLASS : "text-xs font-medium uppercase tracking-[0.16em]"} style={{ color: PROPOSAL_ACCENT }}>
        Why This Option
      </p>
      <p className={pdfPackageMode ? `mt-1.5 ${PDF_BODY_CLASS}` : "mt-2 text-sm leading-7 text-[#374151]"}>{trimmed}</p>
    </div>
  );
}
